module.exports = "float toRadians = 0.01745329252;"